import { urlUtils } from './url';

const getSafeWindow = () => {
  if (typeof window !== 'undefined') {
    return window;
  }
};

const getUrlParam = <T = string>(key: string): T | null => {
  const params = new URLSearchParams(getSafeWindow()?.location.search);
  return params.get(key) as T | null;
};

const extractUrlParam = <T = string>(key: string): T | null => {
  const param = getUrlParam(key);
  removeUrlParam(key);
  return param as T | null;
};

const removeUrlParam = (key: string) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(key);
  window.history.replaceState({}, '', url);
};

const isMobileDevice = (): boolean => {
  const userAgent = getSafeWindow()?.navigator.userAgent ?? '';
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
};

const redirectToUrl = (baseURL: string, params?: Record<string, string | undefined>) => {
  const url = urlUtils.buildUrlWithParams(baseURL, params ?? {});
  window.location.href = url;
};

const getUrlQueryParams = (): Record<string, string | undefined> => {
  return Object.fromEntries(new URLSearchParams(getSafeWindow()?.location.search).entries());
};

const getMobileProvider = (): 'apple' | 'google' | null => {
  switch (true) {
    case /iPhone|iPad|iPod/i.test(navigator.userAgent):
      return 'apple';
    case /Android/i.test(navigator.userAgent):
      return 'google';
    default:
      return null;
  }
};

export const windowUtils = {
  openUrlNewTab: (url: string) => getSafeWindow()?.open(url, '_blank'),
  getSafeWindow,
  extractUrlParam,
  removeUrlParam,
  isMobileDevice,
  redirectToUrl,
  getUrlParam,
  getUrlQueryParams,
  getMobileProvider,
};
